import styled from 'styles/styled-components';
import { Form } from 'formik';

export default styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
  /* removed from sign in page forms */
  /* flex: 1; */
`;